var productionMode = false;
const urlStart = 'https://mpm-tp-dash-op.qtrust.id:1443';

export default {productionMode , urlStart};
